export default __webpack_public_path__ + "appointments/static/media/light-blonde.670a38cc.png";